export function createAction(type) {
  function action(payload) {
    return { payload, type };
  }

  action.type = type;
  action.toString = function toString() {
    return type;
  };

  return action;
}

export function createAsyncAction(type) {
  const action = createAction(type);
  action.fulfilled = createAction(`${type}.fulfilled`);
  action.pending = createAction(`${type}.pending`);
  action.rejected = createAction(`${type}.rejected`);
  action.settled = createAction(`${type}.settled`);
  return action;
}

export function createActions(namespace) {
  return {
    actions: {},
    add(action) {
      this.actions[action] = createAction(`${namespace}.${action}`);
      return this;
    },
    addAsync(action) {
      this.actions[action] = createAsyncAction(`${namespace}.${action}`);
      return this;
    },
  };
}
